/**
 * Purchase Card Custom Element
 * Displays product info, quantity selector, price, and add to cart button in a card UI.
 * Syncs with variant picker and updates dynamically.
 */
if (!customElements.get('purchase-card')) {
  class PurchaseCard extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      this.quantityInput = this.querySelector('.quantity__input');
      this.qtyBadge = this.querySelector('[data-purchase-card-qty-badge]');
      this.variantElement = this.querySelector('[data-purchase-card-variant]');
      this.imageElement = this.querySelector('[data-purchase-card-image]');
      this.variantIdInput = this.querySelector('.product-variant-id');
      this.submitButton = this.querySelector('.product-form__submit');

      this.variantChangeUnsubscriber = undefined;
    }

    connectedCallback() {
      this.setupQuantityListeners();

      // Subscribe to variant changes using Dawn's pubsub system
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          this.onVariantChange.bind(this)
        );
      }
    }

    disconnectedCallback() {
      if (this.variantChangeUnsubscriber) {
        this.variantChangeUnsubscriber();
      }
    }

    setupQuantityListeners() {
      if (!this.quantityInput) return;

      // Listen for quantity input changes
      this.quantityInput.addEventListener('change', () => this.updateQuantityDisplay());

      // Initial update
      this.updateQuantityDisplay();
    }

    updateQuantityDisplay() {
      const quantity = parseInt(this.quantityInput?.value || 1, 10);

      // Update quantity line item
      if (this.qtyBadge) {
        const qtySpan = this.qtyBadge.querySelector('span');
        if (qtySpan) {
          qtySpan.textContent = quantity;
        }
      }
    }

    onVariantChange(event) {
      const { data } = event;

      // Only respond to events from our section
      if (!data || data.sectionId !== this.sectionId) return;

      const variant = data.variant;
      if (!variant) return;

      // Update variant name
      if (this.variantElement) {
        if (variant.title && variant.title !== 'Default Title') {
          this.variantElement.textContent = variant.title;
        } else {
          this.variantElement.textContent = '';
        }
      }

      // Update variant ID in form
      if (this.variantIdInput) {
        this.variantIdInput.value = variant.id;
        this.variantIdInput.disabled = !variant.available;
      }

      // Update submit button state
      if (this.submitButton) {
        this.submitButton.disabled = !variant.available;
        const buttonText = this.submitButton.querySelector('span');
        if (buttonText) {
          if (!variant.available) {
            buttonText.textContent = window.variantStrings?.soldOut || 'Sold out';
          } else {
            buttonText.textContent = window.variantStrings?.addToCart || 'Add to cart';
          }
        }
      }

      // Update featured image if variant has one
      if (this.imageElement && variant.featured_image) {
        const img = this.imageElement.querySelector('img');
        if (img) {
          const imageUrl = variant.featured_image.src;
          // Use Shopify's image size parameter
          img.src = imageUrl.replace(/(\.[^.]+)$/, '_200x$1');
          img.srcset = '';
        }
      }
    }
  }

  customElements.define('purchase-card', PurchaseCard);
}
